import { useState } from 'react';

export function Curiosidade() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section className="py-12 px-5 sm:px-8 lg:px-20 bg-dark">
      <div className="max-w-6xl mx-auto">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full group cursor-pointer"
        >
          <div className="relative bg-gradient-to-r from-gold/5 to-gold/10 rounded-2xl p-6 sm:p-8 border border-gold/20 hover:border-gold/40 transition-all duration-300">
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gold/10 rounded-full flex-shrink-0">
                  <i className="ri-lightbulb-line text-gold text-xl sm:text-2xl"></i>
                </div>
                <h3 className="text-white text-base sm:text-lg lg:text-xl font-semibold text-left">
                  Curiosidade sobre a origem do nome
                </h3>
              </div>
              <div className={`w-8 h-8 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}>
                <i className="ri-arrow-down-s-line text-gold text-2xl"></i>
              </div>
            </div>

            <div
              className={`overflow-hidden transition-all duration-500 ${
                isOpen ? 'max-h-[800px] opacity-100 mt-6' : 'max-h-0 opacity-0'
              }`}
            >
              <div className="space-y-6 pt-6 border-t border-gold/20">
                <p className="text-gray-300 text-sm sm:text-base lg:text-lg leading-relaxed">
                  <strong className="text-white">Mansa Musa JH</strong> une duas referências históricas marcantes:
                </p>

                <div className="grid sm:grid-cols-2 gap-6">
                  <div className="space-y-3 bg-dark-light/50 rounded-xl p-5 sm:p-6 border border-gold/10">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 flex items-center justify-center bg-gold/20 rounded-lg flex-shrink-0">
                        <i className="ri-ancient-gate-line text-gold text-lg"></i>
                      </div>
                      <h4 className="text-gold font-semibold text-base sm:text-lg">Mansa Musa</h4>
                    </div>
                    <p className="text-gray-300 text-sm sm:text-base leading-relaxed">
                      Imperador do Mali no século XIV e considerado um dos homens mais ricos de todos os tempos, símbolo de prosperidade africana e poder estratégico.
                    </p>
                  </div>

                  <div className="space-y-3 bg-dark-light/50 rounded-xl p-5 sm:p-6 border border-gold/10">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 flex items-center justify-center bg-gold/20 rounded-lg flex-shrink-0">
                        <i className="ri-line-chart-line text-gold text-lg"></i>
                      </div>
                      <h4 className="text-gold font-semibold text-base sm:text-lg">Jeremiah G. Hamilton</h4>
                    </div>
                    <p className="text-gray-300 text-sm sm:text-base leading-relaxed">
                      Um dos primeiros negros milionários de Wall Street, referência em inteligência financeira e visão de mercado.
                    </p>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-gold/10 to-transparent rounded-xl p-5 sm:p-6 border-l-4 border-gold">
                  <p className="text-white text-sm sm:text-base lg:text-lg font-medium leading-relaxed">
                    O nome representa a conexão entre <span className="text-gold">riqueza ancestral</span>, <span className="text-gold">estratégia moderna</span> e <span className="text-gold">protagonismo negro</span> nos grandes centros de poder.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </button>
      </div>
    </section>
  );
}
